import React, { useEffect } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { SettingsLayout } from '../../../components/Pleri/components/Settings/SettingsLayout';
import {
  SkillConfig,
  WorkspaceConfig,
} from '../../../components/onboarding/types/onboarding';
import { ToolsContent } from '../../../components/Pleri/components/Library/ToolsContent';
import { useToolsNavigationStore } from '../../../components/onboarding/store/toolsNavigationStore';

// Define search params schema
type ToolsSearchParams = {
  category?: string;
  source?: string;
};

export const Route = createFileRoute('/settings/tools/')({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>): ToolsSearchParams => {
    return {
      category:
        typeof search.category === 'string' ? search.category : undefined,
      source: typeof search.source === 'string' ? search.source : undefined,
    };
  },
});

function RouteComponent() {
  const navigate = useNavigate();
  const search = Route.useSearch();
  const { setSelectedCategory } = useToolsNavigationStore();

  // Set category from URL parameter when component mounts or category changes
  useEffect(() => {
    if (search.category) {
      setSelectedCategory(search.category);
    }
  }, [search.category, setSelectedCategory]);

  const handleSkillSelect = (skill: SkillConfig) => {
    // Navigate to individual skill configuration page
    navigate({
      to: '/settings/tools/skill/$skillId',
      params: { skillId: skill.id },
    });
  };

  const handleWorkspaceSelect = (workspace: WorkspaceConfig) => {
    // Navigate to individual workspace configuration page
    navigate({
      to: '/settings/tools/workspace/$workspaceId',
      params: { workspaceId: workspace.id },
    });
  };

  return (
    <SettingsLayout>
      <ToolsContent
        source={search.source}
        onSkillSelect={handleSkillSelect}
        onWorkspaceSelect={handleWorkspaceSelect}
      />
    </SettingsLayout>
  );
}
